module.exports = __webpack_public_path__ + "static/media/speaker_Veolia_SamiraFazlollahi.dcabe1a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speaker_Veolia_SamiraFazlollahi.jpg
// module id = 258
// module chunks = 0